import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import InnerLoader from "../Loader/InnerLoader";
import { OverlayLoader } from "../Loader/OverlayLoader";

/* refactored - ali */
const SaveDialog = ({
	toggleSaveDialog, onSave, onCancel,
	message, Title, message2,
	SaveButtonText, cancelButtonText,
	showLoader,
	warningIconColor = "warning",
}) => {
	function Save(e) {
		// e.target.disabled = true;
		onSave(e);
	}

	function Cancel(e) {
		e.target.disabled = true;
		onCancel(e);
	}
	return (
		<Dialog width={"30%"} title={Title} onClose={toggleSaveDialog}>
			{showLoader && <OverlayLoader />}
			<div className="d-flex my-3 align-items-center save-content">
				<i className={`fas fa-exclamation-triangle text-${warningIconColor} display-7 me-3`}></i>
				<div>
					{message}
					{message2 && <div className="my-2">{message2}</div>}
				</div>
			</div>

			<DialogActionsBar layout="end">
				<div className="m-3">
					{showLoader && (
						<small className="mt-2">
							<div className="d-inline-block">
								<InnerLoader borderColor="green" />
								<span className="me-4 text-success"></span>
							</div>
						</small>
					)}
					<button className="btn btn-secondary" onClick={Cancel}>
						{cancelButtonText}
					</button>
					<button autoFocus={true} className="btn btn-primary me-2" onClick={Save}>
						{SaveButtonText}
					</button>
				</div>
			</DialogActionsBar>
		</Dialog>
	);
};

export default SaveDialog;
